<template>
  <div>
    <header>
      <div
        class="d-flex flex-row w-100 justify-content-between align-items-center"
      >
        <div class="col">
          <img id="logo" src="@/assets/logo_LBA.jpg" alt="logo LBA" />
        </div>
        <div class="col text-center">
          <h1 class="mb-0">ALLOYS NAVIGATOR</h1>
          <p class="mb-0">Find your perfect material</p>
        </div>
        <div class="col d-flex flex-column text-right">
          <SignOutBtn v-if="store.userIsLoggedIn" />
          <SignInBtn v-else />
          <a class="mail mt-2 mb-4" href="mailto:contact@lebronze-alloys.com">
            <span>REQUEST IDs</span>
            <svg class="ml-2" width="24" height="24" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5l-8-5V6l8 5l8-5v2z"
              />
            </svg>
          </a>
          <SearchBar />
        </div>
      </div>
    </header>
    <div class="container-fluid">
      <div id="alloySelector" class="row">
        <div
          id="filter-panel"
          class=" col-sm-5 col-md-4 no-padding text-left pt-5"
        >
          <AlloysSorting ref="alloySorting" />

          <AlloysFilters
            :alloys="store.alloys"
            :clear-selection="clearSelection"
            :clear-sorting="clearSorting"
          />
        </div>
        <div id="alloys-list-container">
          <div id="alloys-list" class="row m-0 pt-4" @scroll="handleScroll">
            <PremiumAlloyModale
              v-if="premiumPopInDisplay"
              @close="premiumPopInDisplay = false"
            />
            <AlloyItem
              v-for="(alloy, index) in store.alloys"
              :key="
                alloy.brandName + alloy.temper + alloy.isoDesignation + index
              "
              :alloy="alloy"
              :is-selected="isSelected(alloy)"
              :is-active="isActive(alloy, index)"
              @clickOnPremiumAlloy="clickOnPremiumAlloy"
            />
            <p v-if="!store.alloys.length && !loader">
              Dear Sir, Dear Madam,
              <br />
              <br />Thank you for using our alloy navigator. It seems that your
              specifications doesn’t match any of the products we referenced,
              yet we have over 300 alloys in Lebronze Alloys.
              <br />
              <br />To know more about our wide offer of alloys, you can visit
              the following page and contact us through our website:
              <a
                target="_blank"
                href="https://www.lebronze-alloys.com/en/know-how-and-technologies/casting"
                >https://www.lebronze-alloys.com/en/know-how-and-technologies/casting</a
              >
            </p>
          </div>
          <img
            id="bottom-arrow"
            src="@/assets/arrow.png"
            alt
            :class="{ active: displayBottomArrow }"
            @click="scroll('bottom')"
          />
          <img
            id="top-arrow"
            src="@/assets/arrow.png"
            alt
            :class="{ active: displayTopArrow }"
            @click="scroll('top')"
          />
        </div>
        <div id="text-explanation" class="w-100 d-flex p-3">
          <p class="m-auto">
            <span>WELCOME!</span> This tool allows you to navigate through our
            key materials: by combining technical criteria on the left to
            pre-select them, <br />by short-listing your alloys of preference on
            the right, and by comparing them below via datasheets or diagrams.
            <br />
            <b>
              Disclaimer: all information for guidance only, non contractual
              data.
            </b>
          </p>
        </div>
      </div>
      <DataVisualization
        :selected-alloys="selectedAlloys"
        @select-alloy="addSelectedAlloy"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AlloyItem from "@/components/AlloyItem";
import AlloysFilters from "@/components/AlloysFilters";
import AlloysSorting from "@/components/AlloysSorting";
import DataVisualization from "@/components/DataVisualization";
import SearchBar from "@/components/SearchBar";
import SignOutBtn from "@/components/SignOutBtn";
import SignInBtn from "@/components/SignInBtn";
import PremiumAlloyModale from "@/components/PremiumAlloyModale.vue";
import Store from "@/store";
import $ from "jquery";

export default {
  name: "AlloysComparator",
  components: {
    AlloyItem,
    AlloysFilters,
    AlloysSorting,
    DataVisualization,
    SearchBar,
    SignOutBtn,
    SignInBtn,
    PremiumAlloyModale
  },
  data() {
    return {
      selectedAlloys: [],
      activeAlloy: {},
      activeAlloyIndex: -1,
      store: Store.state,
      loader: true,
      premiumPopInDisplay: false,
      displayBottomArrow: true,
      displayTopArrow: false
    };
  },
  created() {
    axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;
    const token = process.env.VUE_APP_ROOT_API_GET_TOKEN;
    if (token) {
      axios.defaults.headers.common["Cockpit-Token"] = token;
      axios
        .get("collections/get/alliages")
        .then(response => {
          this.store.alloys = response.data.entries;
          this.store.alloysBackup = response.data.entries;
          Store.sortAlloysItems();
          this.loader = false;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  methods: {
    handleScroll() {
      this.activeTopArrow();
      this.activeBottomArrow();
    },
    activeTopArrow() {
      if ($("#alloys-list").scrollTop() > 0) {
        this.displayTopArrow = true;
      } else {
        this.displayTopArrow = false;
      }
    },
    activeBottomArrow() {
      if (
        $("#alloys-list").scrollTop() + $("#alloys-list").innerHeight() + 100 >=
        $("#alloys-list").get(0).scrollHeight
      ) {
        this.displayBottomArrow = false;
      } else {
        this.displayBottomArrow = true;
      }
    },
    scroll(direction) {
      var topPos = $("#alloys-list").scrollTop();
      let value = 0;
      if (direction === "bottom") {
        value = topPos + 200;
      } else {
        value = topPos - 200;
      }
      $("#alloys-list").animate(
        {
          scrollTop: value
        },
        "fast"
      );
    },
    isSelected(alloy) {
      return this.selectedAlloys.find(
        a => a.brandName === alloy.brandName && a.temper === alloy.temper
      )
        ? true
        : false;
    },
    isActive(alloy, index) {
      if (
        this.activeAlloy &&
        this.activeAlloy.brandName === alloy.brandName &&
        this.activeAlloy.temper === alloy.temper &&
        this.activeAlloyIndex === index
      )
        return true;
      return false;
    },
    clickOnAlloy(alloy, index) {
      if (
        this.activeAlloy &&
        this.activeAlloy.brandName === alloy.brandName &&
        this.activeAlloy.temper === alloy.temper &&
        this.activeAlloyIndex === index
      ) {
        this.addSelectedAlloy(alloy);
      } else {
        this.addActiveAlloy(alloy, index);
      }
    },
    clickOnPremiumAlloy() {
      this.premiumPopInDisplay = true;
    },
    deactivateAlloy() {
      this.activeAlloy = {};
    },
    addActiveAlloy(alloy, index) {
      this.activeAlloy = alloy;
      this.activeAlloyIndex = index;
    },
    clearSelection() {
      this.selectedAlloys = [];
    },
    clearSorting() {
      this.$refs.alloySorting.resetSorting();
    },
    addSelectedAlloy(alloy) {
      /* On regarde dans le tableau des alliages sélectionnés
        Pour voir si l'élément est présent
      */
      let alloyAlreadySelected = this.selectedAlloys.find(
        a => a.brandName === alloy.brandName && a.temper === alloy.temper
      );
      // Si c'est le cas, on le retire des éléments sélectionnés
      if (alloyAlreadySelected) {
        let index = this.selectedAlloys.indexOf(alloyAlreadySelected);
        this.selectedAlloys.splice(index, 1);
        this.activeAlloy = {};
      }
      // Sinon on l'ajoute
      else {
        if (this.selectedAlloys.length < 5) {
          this.selectedAlloys.push(alloy);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#alloySelector {
  border-bottom: 2px solid rgb(235, 111, 51);

  #text-explanation {
    span {
      color: #d36c48;
      font-weight: bold;
    }
  }
  .no-padding {
    padding: 0;
  }
  #alloys-list-container {
    position: relative;
    flex: 1;
  }
  #alloys-list {
    overflow-x: hidden;
    overflow-y: scroll;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height: 565px;
    align-content: flex-start;
    &::-webkit-scrollbar {
      width: 12px;
      height: 20px;
    }
    &::-webkit-scrollbar-track {
      border-width: 4px 0 0;
      background-color: rgba(0, 0, 0, 0.1);
    }
    &::-webkit-scrollbar-thumb {
      padding: 0 0 0 100px;
      background-color: rgba(0, 0, 0, 0.2);
    }

    &::-webkit-scrollbar-track {
      border-width: 6px 0 1px;
    }
    p {
      width: 75%;
      text-align: left;
      padding: 16px;
      a {
        color: #d36c48;
      }
    }
  }
}
#top-arrow,
#bottom-arrow {
  position: absolute;
  cursor: pointer;
  opacity: 0.8;
  visibility: hidden;
  transition: opacity 0.3s ease;
  transform: rotate(90deg);

  &.active {
    visibility: visible;
  }
  &:hover {
    opacity: 1;
  }
}
#bottom-arrow {
  border-radius: 5px 0 0 5px;
  background-color: white;
  padding: 10px;
  bottom: 0;
  left: 50%;
  width: 50px;
  transform: rotate(90deg) translateY(50%);
}
#top-arrow {
  border-radius: 5px 0 0 5px;
  background-color: white;
  padding: 10px;
  top: 0;
  left: 50%;
  width: 50px;
  transform: rotate(270deg) translateY(-50%);
}
.mail {
  font-size: 14px;
  color: #2c3e50;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: rgb(235, 111, 51);
  }

  svg {
    margin-top: -0.17rem;
  }
}
</style>
